// Профиль путешественника: чистая логика без React и хранилища — попутчики, состав поездки, срок паспорта
import type { Profile, Traveler } from '../../shared/lib/types';

const MAX_TRAVELERS = 9;

/** Попутчики из хранилища → проверенный список (имя обязательно, возраст ребёнка 0–17, гражданство — 2 буквы) */
export function cleanTravelers(raw: unknown): Traveler[] {
  if (!Array.isArray(raw)) return [];
  const out: Traveler[] = [];
  for (const x of raw as Partial<Traveler>[]) {
    if (!x || typeof x !== 'object') continue;
    const name = typeof x.name === 'string' ? x.name.trim().slice(0, 60) : '';
    if (!name) continue;
    const age = typeof x.age === 'number' && Number.isInteger(x.age) && x.age >= 0 && x.age < 18 ? x.age : null;
    const t: Traveler = { id: typeof x.id === 'string' && /^[\w-]{1,40}$/.test(x.id) ? x.id : `t${out.length}`, name, age };
    if (typeof x.citizenship === 'string' && /^[A-Z]{2}$/.test(x.citizenship)) t.citizenship = x.citizenship;
    if (typeof x.passport === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(x.passport)) t.passport = x.passport;
    out.push(t);
    if (out.length >= MAX_TRAVELERS) break;
  }
  return out;
}

/** Состав поездки по профилю: сам путешественник (взрослый) и попутчики; младенцы — до 2 лет */
export function partyOf(p: Pick<Profile, 'travelers'>): { adults: number; children: number; infants: number; childAges: number[] } {
  const list = cleanTravelers(p.travelers);
  const kids = list.filter((t) => t.age !== null).map((t) => t.age as number);
  return {
    adults: 1 + list.filter((t) => t.age === null).length,
    children: kids.filter((a) => a >= 2).length,
    infants: kids.filter((a) => a < 2).length,
    childAges: kids,
  };
}

/** Имена всех, кто едет: путешественник («Я», если имя не указано) и попутчики */
export function travelerNames(p: Pick<Profile, 'name' | 'travelers'>): string[] {
  return [p.name?.trim() || 'Я', ...cleanTravelers(p.travelers).map((t) => t.name)];
}

/** Паспорт к концу поездки: истекает раньше ('expired'), меньше 6 месяцев запаса ('short') или в порядке ('') */
export function passportProblem(passport: string | null | undefined, lastDay: string): 'expired' | 'short' | '' {
  if (!passport || !lastDay) return '';
  const left = (Date.parse(passport) - Date.parse(lastDay.slice(0, 10))) / 86400000;
  if (Number.isNaN(left)) return '';
  if (left < 0) return 'expired';
  return left < 183 ? 'short' : '';
}
